import React, { Fragment, useContext } from 'react';
// eslint-disable-next-line no-unused-vars
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import { Tr } from '@lsoft/translate';
// noinspection ES6CheckImport
import { MuiFormatDate } from '@lsoft/mui';
import {
	trAvailableForPreOrder,
	trComingSoon,
	trDeliveryDigital,
	trDeliveryExpected,
	trDeliveryTimeOneRequest,
	trExceptedAvailableFrom,
	trInStock,
	trInStockLimitedAmount,
	trNotInStock,
	trReadyForDeliveryNextBusinessDay,
	trReadyForDeliverySixTenBusinessDays,
	trReadyForDeliveryTwoFiveBusinessDays,
} from './Product.tr';
import { ProductContext } from '@lsoft/shared/container/Product';

const useStyles = makeStyles((theme) => ({
	stockGreen: {
		color: theme.palette.success.main,
	},
	stockOrange: {
		color: theme.palette.warning.main,
	},
	stockGrey: {
		color: theme.palette.text.secondary,
	},
	stockRed: {
		color: theme.palette.error.main,
	},
}));
const stock_info_trs = {
	on_stock: {
		title: trInStock,
		caption: trReadyForDeliveryNextBusinessDay,
	},
	on_stock_limited_amount: {
		title: trInStockLimitedAmount,
		caption: trReadyForDeliveryNextBusinessDay,
	},
	short_term: {
		title: trDeliveryExpected,
		caption: trReadyForDeliveryTwoFiveBusinessDays,
	},
	mid_term: {
		title: trDeliveryExpected,
		caption: trReadyForDeliverySixTenBusinessDays,
	},
	presale: {
		title: trAvailableForPreOrder,
		caption: trExceptedAvailableFrom,
	},
	delivery_date: {
		title: trDeliveryExpected,
		caption: trExceptedAvailableFrom,
	},
	coming_soon: {
		title: trComingSoon,
		caption: trExceptedAvailableFrom,
	},
	request: {
		title: trNotInStock,
		caption: trDeliveryTimeOneRequest,
	},
	digital: {
		title: trInStock,
		caption: trDeliveryDigital,
	},
};

const RealStockInfoCaption = ({ variant, amount }) => {
	const stockInfoTr = stock_info_trs[variant];
	const text = stockInfoTr.caption;
	return (
		<>
			<Tr tr={text} />
		</>
	);
};

const RealStockInfoTitle = ({ variant, max_stock_available }) => {
	const realVariant = max_stock_available ? 'on_stock_limited_amount' : variant;
	const stockInfoTr = stock_info_trs[realVariant];
	const text = stockInfoTr.title;
	return <Tr tr={text} format={{ amount: max_stock_available }} />;
};

export const ShopProductStockInfo = ({ theme, variant, titleVariant }) => {
	const classes = useStyles(theme);
	// noinspection JSCheckFunctionSignatures
	const { data: productData } = useContext(ProductContext);
	const { delivery_date, availability_date, max_stock_available } = productData;

	return (
		<Fragment>
			<Typography
				className={clsx({
					[classes.stockGrey]: ['coming_soon', 'request'].includes(variant),
					[classes.stockGreen]: ['on_stock', 'digital'].includes(variant),
					[classes.stockOrange]: [
						'short_term',
						'mid_term',
						'presale',
						'delivery_date',
					].includes(variant),
				})}
				variant={titleVariant}
			>
				<RealStockInfoTitle
					variant={variant}
					max_stock_available={max_stock_available}
				/>
			</Typography>
			<Typography variant={'caption'}>
				<RealStockInfoCaption variant={variant} />
				{_.includes(['coming_soon', 'presale', 'delivery_date'], variant) && (
					<Fragment>
						&nbsp;
						<strong>
							<MuiFormatDate
								date={
									variant !== 'delivery_date'
										? availability_date
										: delivery_date
								}
							/>
						</strong>
					</Fragment>
				)}
			</Typography>
		</Fragment>
	);
};

ShopProductStockInfo.propTypes = {
	titleVariant: PropTypes.string,
	variant: PropTypes.oneOf([
		'coming_soon',
		'presale',
		'on_stock',
		'short_term',
		'mid_term',
		'delivery_date',
		'request',
		'digital',
	]).isRequired,
};
